export enum HeaderType {
  Small = 'small',
  Big = 'big',
}

export type UIState = {
  headerType: HeaderType;
}